
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import Popup from 'reactjs-popup'

import Button from '@material-ui/core/Button'
import * as appActions from '../../store/actions/appActions'
import * as transcriptViewerActions from '../../pages/transcript-viewer/transcriptViewerActions'

import './PopupWrapper.scss'

const actions = { appActions, transcriptViewerActions };

const PopupWrapper = ({ popupParams, closePopup }) => {
  const { isOpen, text, btns1, btns2, confirm, cancel } = popupParams
  function fireOnConfirm() {
    closePopup();
    if (confirm) {
      const { actionType, actionName, actionParams } = confirm
      window.store.dispatch(actions[actionType][actionName](actionParams))
    }
  }
  function fireOnCancel() {
    closePopup();
    if (cancel) cancel()
  }

  return (
    <Popup open={isOpen} closeOnDocumentClick onClose={fireOnCancel}>
      <div className="modal">
        {/* <a className="popup_close-btn" onClick={closeModal}>&times;</a> */}
        {text ? <div className="popup_text">{text}</div> : null }
        <div className="popup_btns">
          {btns1.map((btnText, ii) => <Button className="popup_btn1" variant="contained" onClick={fireOnConfirm} key={ii}>{btnText}</Button>)}
          {btns2.map((btnText, ii) => <Button className="popup_btn2" variant="outlined" onClick={fireOnCancel} key={ii}>{btnText}</Button>)}
        </div>
      </div>
    </Popup>
  )
}

PopupWrapper.propTypes = {
  popupParams: PropTypes.object.isRequired,
  closePopup: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    popupParams: state.app.popupParams,
  }),
  dispatch => bindActionCreators({
    closePopup: appActions.closePopup,
  }, dispatch),
)(PopupWrapper);
